(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lilbattlePages", [], factory);
	else if(typeof exports === 'object')
		exports["lilbattlePages"] = factory();
	else
		root["lilbattlePages"] = root["lilbattlePages"] || {}, root["lilbattlePages"]["GameListingPage"] = factory();
})(this, () => {
return 